import { configureStore } from '@reduxjs/toolkit';
import scriptItemReducer from './ScriptItemSlice'

const scriptItemStore = configureStore({
  reducer: {
    scriptItems: scriptItemReducer
  }
});

export default scriptItemStore;